import React, { forwardRef } from 'react';
import {
  RadioGroupProps,
  RadioGroup as ChakraRadioGroup,
} from '@chakra-ui/react';

interface Props extends RadioGroupProps {
  children: React.ReactNode;
  name: string;
}

export const RadioGroup = forwardRef<HTMLInputElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <ChakraRadioGroup ref={ref} {...props}>
        {children}
      </ChakraRadioGroup>
    );
  }
);
export type { Props as RadioGroupProps };
